import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import StorybookBlueBubbleItemComponent from 'webapp/components/storybook/blue-bubble-item';
import type StorybookBubblesController from 'webapp/controllers/storybook/bubbles';

interface Args {
	controller: StorybookBubblesController;
}

const StorybookBubblesRouteTemplate: TOC<Args> = <template>
	<h1 class="storybook-title">
		<LinkTo @route="storybook" class="storybook-title__back" aria-label="Back to storybook">
			<CommonUiIconComponent @name="ArrowLeft" @size="lg" />
		</LinkTo>
		Blue Bubble Tours
	</h1>

	{{#each @controller.bubbleCategories as |category|}}
		<h2>{{category.name}}</h2>
		<div class="grid bubbles-grid">
			{{#each category.items as |bubble|}}
				<div class="item">
					<div class="item__title">
						{{bubble.label}}
					</div>
					<div class="item__content">
						<StorybookBlueBubbleItemComponent
							@type={{bubble.type}}
							@step={{bubble.step}}
						/>
					</div>
				</div>
			{{/each}}
		</div>
	{{/each}}
</template>;

export default StorybookBubblesRouteTemplate;
